<template>
  <div>
    <SignupSplashScreen
      :is-referral="isReferral"
      :referral-data="referralData"
      :referral="referral"
      :completed-referral-flow="completedReferralFlow"
    />
  </div>
</template>

<script>
/* NOTE! This component is just a wrapper for the Splash Screen component for backwards compatibility reasons */

export default {
  props: {
    isReferral: {
      type: Boolean,
      default: false
    },
    completedReferralFlow: {
      type: Boolean,
      default: false
    },
    referralData: {
      type: Object,
      default: () => ({})
    },
    referral: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
